import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  buttonGroup: {
    backgroundColor: '#F5F5F5',
    borderRadius: 30,
    fontFamily: 'Outfit-Regular',
  },
}));
